import { loadStripe } from '@stripe/stripe-js';
import { useAppState, useAppDispatch } from '../../Shared/AppContext';

export function useGroupState() {
  return useAppState();
}

export function useGroupActions() {
  const dispatch = useAppDispatch();

  function initializeState(groupId, { stripePublishableKey } = {}) {
    const key = stripePublishableKey || null;
    dispatch((appState) => ({
      ...appState,
      loading: true,
      group: {
        id: groupId,
        budgets: [],
        purchaseOrderGroups: [],
        inventories: [],
        people: [],
        rootPath: '',
        path: '',
      },
      stripePublishableKey: key,
      stripePromise: key ? loadStripe(key) : null,
      groupPaymentMethod: null,
      cardFormIsOpen: false,
      cardFormProcessing: false,
      clientSecret: null,
      feedbackMessage: null,
      feedbackVariant: null,
    }));
  }

  function onResponse(response) {
    dispatch((appState) => ({ ...appState, ...response }));
  }

  function onError(feedback) {
    dispatch((appState) => ({ ...appState, ...feedback }));
  }

  function getFeedbackFromLocalStorage(feedbackMessage, feedbackVariant) {
    dispatch((appState) => ({
      ...appState,
      feedbackMessage: feedbackMessage,
      feedbackVariant: feedbackVariant,
    }));
  }

  function clearFeedback() {
    dispatch((appState) => ({
      ...appState,
      feedbackMessage: null,
      feedbackVariant: null,
    }));
  }

  function openDeleteGroupModal() {
    dispatch((appState) => ({
      ...appState,
      deleteGroupModalIsOpen: true,
      deleteGroupConfirmationPhrase: '',
      deleteGroupPassword: '',
    }));
  }

  function closeDeleteGroupModal() {
    dispatch((appState) => ({
      ...appState,
      deleteGroupModalIsOpen: false,
      deleteGroupConfirmationPhrase: '',
      deleteGroupPassword: '',
    }));
  }

  function updateDeleteGroupConfirmationPhrase(value) {
    dispatch((appState) => ({
      ...appState,
      deleteGroupConfirmationPhrase: value,
    }));
  }

  function updateDeleteGroupPassword(value) {
    dispatch((appState) => ({
      ...appState,
      deleteGroupPassword: value,
    }));
  }

  function openCardForm() {
    dispatch((appState) => ({
      ...appState,
      cardFormIsOpen: true,
      cardFormProcessing: false,
      clientSecret: null,
    }));
  }

  function closeCardForm() {
    dispatch((appState) => ({
      ...appState,
      cardFormIsOpen: false,
      cardFormProcessing: false,
      clientSecret: null,
    }));
  }

  function setCardFormProcessing(processing) {
    dispatch((appState) => ({
      ...appState,
      cardFormProcessing: processing,
    }));
  }

  return {
    initializeState,
    onResponse,
    onError,
    getFeedbackFromLocalStorage,
    clearFeedback,
    openDeleteGroupModal,
    closeDeleteGroupModal,
    updateDeleteGroupConfirmationPhrase,
    updateDeleteGroupPassword,
    openCardForm,
    closeCardForm,
    setCardFormProcessing,
  };
}
